import React from "react";
import Icon from "../../../components/AppIcon";

const VenueDisplay = ({ order }) => {


    if (order.diagnosticCenter) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex-shrink-0">
          <div className="w-7 h-7 bg-purple-50 rounded-lg flex items-center justify-center border border-purple-100">
            <Icon name="Store" size={14} className="text-purple-600" />
          </div>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 flex-wrap">
            <span className="text-xs font-medium text-gray-900 truncate" title={order.diagnosticCenter.name}>
              {order.diagnosticCenter.name}
            </span>
           
          </div>
          {order.diagnosticCenter.address && (
            <p className="text-[10px] text-gray-500 mt-0.5 truncate" title={order.diagnosticCenter.address}>
              {order.diagnosticCenter.address}
            </p>
          )}
        </div>
      </div>
    );
  }

  return (
    <span className="text-xs text-gray-400 italic">—</span>
  );
  
};

export default VenueDisplay;